import { AxiosResponse } from "axios";
import {createContext, useContext} from "react";
import * as React from "react";
import {
  useMutation,
  UseMutationResult,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from "react-query";

import {
  getCurrentUser as apiGetCurrentUser,
  login as apiLogin,
  logout as apiLogout
} from "../Api";
import { UserDto } from "../model/Dto";
import {authenticationKeys} from "../QueryKeys";

export type LoginParams = {
  username: string;
  password: string;
};

export type AuthenticationProps = {
  currentUserQuery: UseQueryResult<AxiosResponse<UserDto>, Error>;
  loginMutation: UseMutationResult<AxiosResponse<void>, Error, LoginParams>;
  logoutMutation: UseMutationResult<AxiosResponse<void>, Error>;
};

const authenticationContext = createContext<Partial<AuthenticationProps>>({});

export function useAuthentication() {
  return useContext(authenticationContext);
}

export function AuthenticationProvider({ children }: any) {
  const queryClient = useQueryClient();

  const currentUserQuery = useQuery<AxiosResponse<UserDto>, Error>(
    authenticationKeys.currentUser(),
    apiGetCurrentUser,
    {
      // 5 min + 10s
      refetchInterval: (data) => (data !== undefined ? 1000 * 310 : false),
      enabled:true,
      refetchIntervalInBackground: true,
      refetchOnMount: 'always',
      refetchOnWindowFocus: false // REVISAR ESTO
    }
  );

  const loginMutation = useMutation<AxiosResponse<void>, Error, LoginParams>(
    ({ username, password }: any) => {
      return apiLogin(username, password);
    },
    {
      onSuccess: () => {
        return queryClient.invalidateQueries(authenticationKeys.currentUser());
        },
    }
  );

  const logoutMutation = useMutation<AxiosResponse<void>, Error, unknown>(
      () => apiLogout(),
      {
        onSuccess: () =>
            queryClient.resetQueries(authenticationKeys.currentUser()),
      }
  );

  return (
    <authenticationContext.Provider
      value={{
        currentUserQuery,
        loginMutation,
        logoutMutation
      }}
    >
      {children}
    </authenticationContext.Provider>
  );
}
